import { render, staticRenderFns } from "./CardapioView.vue?vue&type=template&id=2d01eb72&scoped=true&"
import script from "./CardapioView.vue?vue&type=script&lang=js&"
export * from "./CardapioView.vue?vue&type=script&lang=js&"
import style0 from "./CardapioView.vue?vue&type=style&index=0&id=2d01eb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01eb72",
  null
  
)

export default component.exports